import SocketController from './Socket';

class VideoSocketController extends SocketController {}

export default new VideoSocketController('video');
